import React from 'react';

export default function NDA() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center p-6">
      <div className="w-full max-w-3xl bg-white rounded-xl shadow-lg p-6">
        <h1 className="text-lg font-semibold text-gray-800">
          Ronald Industries requires you to sign the NDA before accessing their
          RFQ.
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          This ensures confidentiality and protects sensitive information shared
          in the RFQ process.
        </p>

        {/* Document name and action buttons */}
        <div className="flex items-center bg-gray-100 p-1 px-2 rounded justify-between mt-6">
          <label className="text-sm font-medium font-semibold text-gray-700">
            Name of the document
          </label>
          <div className="space-x-2">
            <button className="text-darkerPurple border border-darkerPurple rounded bg-white px-3 text-sm hover:bg-gray-200">
              Suggest
            </button>
            <button className="text-darkerPurple border border-darkerPurple rounded px-3 bg-white text-sm hover:bg-gray-200">
              Download
            </button>
          </div>
        </div>

        {/* NDA Preview Area */}
        <div className="mt-4 bg-veryVeryLightPurple text-center text-3xl text-black py-24 rounded">
          NDA visible here
        </div>

        {/* Upload Section */}
        <div className="mt-6 bg-gray-50 p-2 px-3 rounded">
          <label className="block text-sm text-darkerPurple font-semibold bg-gray-100 p-1 font-medium mb-4">
            Upload Signed NDA
          </label>
          <div className="flex items-center space-x-2">
            <input type="file" className="hidden" id="uploadNDA" />
            <label
              htmlFor="uploadNDA"
              className="cursor-pointer bg-white border border-darkerPurple text-darkerPurple px-4 py-2 rounded hover:bg-gray-200 text-sm"
            >
              Upload NDA
            </label>
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-6 text-center">
          <button className="bg-lightPurple text-white px-6 py-2 rounded hover:bg-darkPurple">
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
